export const injectGtagScript = () => {
  const tagId = process.env['REACT_APP_GA_MEASUREMENT_ID'];
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${tagId}`;
  const head = document.getElementsByTagName('head')[0];
  head.appendChild(s);
};
